export const PeriodColors = ['var(--color-green-6)', 'var(--color-orange-6)', 'var(--color-red-6)']
